import './PaymentMethodDialog.less';
import React from 'react';
import __ from "../../i18n";
import NoticeBox, {NOTICE_INFO} from "../../../bootstrap/components/notice-box/NoticeBox";
import config from "../../../../../config.json";


export default function PaymentMethodDialog({instruction, amount, bankTransferContent}) {

    return <div className="payment-method-dialog">
        <NoticeBox
            type={NOTICE_INFO}
            message={instruction}
        />
        <div className="group">
            <h4>{__('Transfer content:')}</h4>
            <div>
                <span className="transfer-content">
                    {bankTransferContent}
                </span>
            </div>
        </div>
        <div className="group">
            <h4>{__('Amount:')}</h4>
            <div>{__('::amount(CURRENCY)', {amount})}</div>
        </div>
        <div className="group">
            <h4>{__('Bank accounts:')}</h4>
            <table>
                {
                    config.bankAccounts.map((item, index) => (
                        <tbody key={index}>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td className="img-cell" rowSpan={3}>
                                    <img src={item.bankLogo} alt={item.bankName}/>
                                </td>
                                <td colSpan={2}>
                                    <b>{item.bankName}</b>
                                    <br/>
                                    {__('Branch: ::bankBranch', {bankBranch: item.bankBranch})}
                                </td>
                            </tr>
                            <tr>
                                <th>{__('Account name:')}</th>
                                <td>{item.accountName}</td>
                            </tr>
                            <tr>
                                <th>{__('Account number:')}</th>
                                <td>{item.accountNumber}</td>
                            </tr>
                        </tbody>
                    ))
                }
            </table>
        </div>
    </div>;
}
